// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  campaign: __t.string(),
  node: __t.string(),
  flags: __t.array(__t.string()),
  regions: __t.array(__t.string()),
  biomes: __t.array(__t.string()),
  history: __t.array(__t.string()),
  wonLast: __t.bool().name("won_last"),
  finished: __t.bool(),
  relics: __t.u32(),
});
